import React, { useState, useEffect } from 'react';
import { Modal, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import MarketArea from '../../../../public/assets/MarketArea.svg';
import LeadConnection from '../../../../public/assets/LeadConnection.svg';
import Scorecard from '../../../../public/assets/Scorecard.svg';
import logo_between from '../../../../public/assets/logo_between.png';
import toast from 'react-hot-toast';
import { styled } from '@mui/material/styles';
import Badge from '@mui/material/Badge';
import CircularProgress from '@mui/material/CircularProgress';
import Avatar from '@mui/material/Avatar';
import LeadService from '../../../core/services/leadsService';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';
import { BsTelephoneFill } from 'react-icons/bs';
import { MdEmail } from 'react-icons/md';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LogoutExpiredModal from '../../LogoutExpiredModal';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import CustomerLeadProfile from '../CustomerLeadProfile/CustomerLeadProfile';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { format } from 'date-fns';
import AgentSchedulingModal from './AgentSchedulingModal'; // import your modal component
import AgentTags from '../../../pages/AgentTags/AgentTags';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

const BorderLinearProgressTwo = styled(LinearProgress)(({ theme, barColor }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: barColor || (theme.palette.mode === 'black' ? 'black' : '#00BF2A'),
    },
}));
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
    '& .MuiDialog-paper': {
        borderRadius: '20px', // Set your desired border radius here
    },
}));
const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));

const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
        backgroundColor: '#44b700',
        color: '#44b700',
        boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
        '&::after': {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            border: '1px solid currentColor',
            content: '""',
        },
    },
}));
const SmallAvatar = styled(Avatar)(({ theme }) => ({
    width: 22,
    height: 22,
    border: `2px solid ${theme.palette.background.paper}`,
}));
const barColorStatus = {
    active: { color: '#00000F' },
    new: { color: '#00000F' },
    attempting_contact: { color: '#9B0000' },
    spoke_with_customer_new: { color: '#00000F' },
    spoke_with_customer: { color: '#00BF2A' },
    appointment_set: { color: '#00BF2A' },
    met_with_customer: { color: '#7400C2' },
    showing_homes: { color: '#ED7DB1' },
    submitting_offers: { color: '#6EA478' },
    under_contract_escrow: { color: '#4C489B' },
    bamfam: { color: '#6691CB' },
    nurture: { color: '#9B5B00' },
    nurture_after_sale: { color: '#9B5B5B' },
    closed: { color: '#F17105' },
    rejected: { color: '#ED0423' },
    not_interested: { color: '#ebc3c3' },
    refinance_referral: { color: '#9B5B5B' },
    personal_lead: { color: '#9B5B5B' },
    agent: { color: '#121212' },
    bad_lead: { color: '#2e1414' },
    buy_side_contract: { color: '#9B5B5B' },
    dnc: { color: '#9B5B5B' },
    buyer_broker_signed: { color: '#FE0083' },
    cancelled: { color: '#4c489b' },
    valuation_appointment: { color: '#c7b9b00' },
    listing_signed: { color: '#c29800' },
    listing_appointment: { color: '#cb5935' },
    follow_up: { color: '#469990' },
    listing_under_contract: { color: '#950e3f' },
};
const AgentProfile = ({ selectedAgent, properties, setSelectedAgent, handleAssignLead, searchValue }) => {
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [expanded, setExpanded] = React.useState(false);
    const [expandedAssignment, setExpandedAssignment] = React.useState(false);
    const [showPhoneNumber, setShowPhoneNumber] = useState(false);
    const [agentDetails, setAgentDetails] = useState('');
    const [IcaAgentTags, setIcaAgentTags] = useState([]);
    const [agentProfileImage, setAgentProfileImage] = useState('');
    const [assignLead, setAssignLead] = useState([]);
    const [agentId, setAgentId] = React.useState('');
    const [expandedBio, setExpandedBio] = useState(false);
    const [statusCounts, setStatusCounts] = useState({});
    const [logOutModal, setLogOutModal] = useState(false);
    const [totalStatusCounts, setTotalStatusCounts] = useState('');
    const [leadId, setLeadId] = useState('');
    const [dateRange, setDateRange] = useState({ start_date: '', end_date: '' });
    const email = agentDetails?.email;
    const gmailComposeUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}`;
    const [currentTime, setCurrentTime] = useState(new Date());
    const [openModal, setOpenModal] = useState(false);

    // Update time every second
    useEffect(() => {
        const timer = setInterval(() => setCurrentTime(new Date()), 1000);
        return () => clearInterval(timer);
    }, []);
    const handleOpenModal = () => setOpenModal(true);
    const handleCloseModal = () => setOpenModal(false);

    const toggleExpand = () => {
        setExpandedBio(!expandedBio);
    };

    const handleCloseAgentIcon = async () => {
        setSelectedAgent(null);
        setOpen(false);
    };

    useEffect(() => {

        if (selectedAgent && properties?.length !== 1 && !loading) {
            setLoading(true);
        }
        if (selectedAgent?.id) {
            setAgentId(selectedAgent.id);
            setOpen(true);
            setLoading(false);
        }
        else {
            setOpen(false);
            setLoading(false);
        }
    }, [selectedAgent, properties]);



    const handleClose = () => {
        setOpen(false);
    };

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    const handleExpandAssignmentClick = () => {
        setExpandedAssignment(!expandedAssignment);
    };

    const getAgentProfileDetail = async (agentId) => {
        try {
            setLoading(true);
            const res = await LeadService.GetAgentProfileDetail(agentId);
            if (res?.data?.success) {
                toast.success(res?.data?.message);
                setAgentDetails(res?.data?.agent);
                setIcaAgentTags(res?.data?.agent?.tags);
                setAgentProfileImage(res?.data?.agent.profile_image);
                setAssignLead(res?.data.agent?.assignLeads?.data);
            }
        } catch (error) {
            console.error(error);
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };
    const handleICAGetStatusScoring = async () => {
        try {
            const res = await LeadService.ICAGetStatusScoring();
            if (res?.data?.success) {
                setStatusCounts(res?.data?.status_counts);
                setDateRange({
                    start_date: res?.data?.start_date,
                    end_date: res?.data?.end_date,
                });
                setTotalStatusCounts(res?.data?.total_count);
                return;
            }
        } catch (error) {
            if (error.message === 'You have been logged out of the application, please login again to use the application.') {
                setLogOutModal(true);
            } else {
                toast.error(error.message);
            }
        }
    };

    useEffect(() => {
        handleICAGetStatusScoring();
    }, []);

    useEffect(() => {
        if (agentId) {
            getAgentProfileDetail(agentId);
        }
    }, [agentId]);

    const adjustTimeBasedOnOffsetForReceivedData = (dateString, offsetInHours) => {
        const date = new Date(dateString);
        // Convert to UTC and then apply offset
        const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
        utcDate.setHours(utcDate.getHours() + offsetInHours);
        return utcDate;
    };

    const getUserOffset = () => {
        const offset = localStorage.getItem('userOffset');
        return offset ? parseFloat(offset) : 0;
    };

    const formatDateTime = (date) => {
        const options = { year: 'numeric', month: 'long', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true };
        return date.toLocaleDateString(undefined, options).replace(',', '');
    };
    const userOffset = getUserOffset();
    const adjustedDate = adjustTimeBasedOnOffsetForReceivedData(agentDetails.created_at, userOffset);

    const formattedDate = adjustedDate ? formatDateTime(adjustedDate) : 'No date available';

    const mapStatusToFormatAndColor = (status) => {
        const statusMapping = {
            active: { text: ' ● New ', color: '#00000F' },
            new: { text: ' ● New ', color: '#00000F' },
            attempting_contact: { text: ' ● Attempting Contact ', color: '#9B0000' },
            spoke_with_customer_new: { text: ' ● New ', color: '#00000F' },
            spoke_with_customer: { text: ' ● Spoke with customer ', color: '#00BF2A' },
            appointment_set: { text: ' ● Appointment Set ', color: '#00BF2A' },
            met_with_customer: { text: ' ● Met with customer ', color: '#7400C2' },
            showing_homes: { text: ' ● Showing Homes ', color: '#ED7DB1' },
            submitting_offers: { text: ' ● Submitting Offers ', color: '#6EA478' },
            under_contract_escrow: { text: ' ● Under Contract/Escrow ', color: '#4C489B' },
            bamfam: { text: ' ● BAMFAM ', color: '#6691CB' },
            nurture: { text: ' ● Nurture Before sale ', color: '#9B5B00' },
            nurture_after_sale: { text: ' ● Nurture After Sale ', color: '#9B5B5B' },
            closed: { text: ' ●  Sale Closed ', color: '#F17105' },
            rejected: { text: ' ● Rejected ', color: '#ED0423' },
            not_interested: { text: ' ● Not Interested ', color: '#ebc3c3' },
            refinance_referral: { text: ' ● Refinance Referral ', color: '#9B5B5B' },
            personal_lead: { text: ' ● Personal Lead ', color: '#9B5B5B' },
            agent: { text: ' ● Agent ', color: 'white' },
            bad_lead: { text: ' ● Bad Lead ', color: '#2e1414' },
            buy_side_contract: { text: ' ● Buy Side Contract ', color: '#9B5B5B' },
            dnc: { text: ' ● DNC ', color: '#9B5B5B' },
            buyer_broker_signed: { text: ' ● Buyer Broker Signed ', color: '#FFFFFF' },
            cancelled: { text: ' ● Cancelled ', color: '#FFFFFF' },
            valuation_appointment: { text: ' ● Valuation Appointment ', color: '#FFFFFF' },
            listing_signed: { text: ' ● Listing Signed ', color: '#FFFFFF' },
            listing_appointment: { text: ' ● Listing Appointment ', color: '#FFFFFF' },
            follow_up: { text: ' ● Follow Up ', color: '#FFFFFF' },
        };
        const divBackgroundColors = {
            active: '#e9e4e4',
            new: '#e9e4e4',
            attempting_contact: '#ababef',
            spoke_with_customer_new: '#ababef',
            spoke_with_customer: '#bee5c6',
            appointment_set: '#bee5c6',
            met_with_customer: '#d9c2e9',
            showing_homes: '#f9d5e6',
            submitting_offers: '#bbe3c2',
            under_contract_escrow: '#c1bfed',
            bamfam: '#edeff5',
            nurture: '#f9deb8',
            nurture_after_sale: '#e7c612',
            closed: '#fff0e3',
            rejected: '#fbdfe2',
            not_interested: '#df3271',
            refinance_referral: '#e7e2c7',
            agent: '#5500CC',
            personal_lead: '##fff',
            bad_lead: '#c12f0d',
            buy_side_contract: '#e7c612',
            dnc: '#A87BFF',
            buyer_broker_signed: '#FABED4',
            cancelled: '#4C489B',
            valuation_appointment: '#7D9B00',
            listing_signed: '#C29800',
            listing_appointment: '#CB5935',
            follow_up: '#2e7a5c',
        };
        const divBorder = {
            active: '1px solid black',
            new: '1px solid black',
            attempting_contact: '1px solid #9B0000',
            spoke_with_customer_new: '1px solid #00000F',
            spoke_with_customer: '1px solid #00BF2A',
            appointment_set: '1px solid #00BF2A',
            met_with_customer: '1px solid #7400C2',
            showing_homes: '1px solid #ED7DB1',
            submitting_offers: '1px solid #6EA478',
            under_contract_escrow: '1px solid #4C489B',
            bamfam: '1px solid #6691CB',
            nurture: '1px solid #9B5B00',
            nurture_after_sale: '1px solid #9B5B5B',
            closed: '1px solid #F17105',
            rejected: '1px solid #ED0423',
            not_interested: '1px solid #a9199f',
            refinance_referral: '1px solid #a99497',
            agent: '1px solid #5500CC',
            personal_lead: '1px solid #a99497',
            bad_lead: '1px solid #5c433b',
            buy_side_contract: '1px solid #9B5B5B',
            dnc: '1px solid #9B5B5B',
            buyer_broker_signed: '1px solid #FABED4',
            cancelled: '1px solid #4C489B',
            valuation_appointment: '1px solid #7D9B00',
            listing_signed: '1px solid #483c10',
            listing_appointment: '1px solid #CB5935',
            follow_up: '1px solid #2d6f55',
        };

        const { text, color } = statusMapping[status] || { text: status, color: '#000000' };
        const divBackgroundColor = divBackgroundColors[status] || 'transparent';
        const border = divBorder[status] || '1px solid black';
        return {
            formattedStatus: <span style={{ color }}>{text}</span>,
            divStyle: {
                background: divBackgroundColor,
                border,
            },
        };
    };

    const handleOpenById = (selectedAgent) => {
        setLeadId(selectedAgent);
    };

    return (
        <div>
            <>
                {loading ? (
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '100vh',
                        }}
                    >
                        <CircularProgress sx={{ color: 'red' }} />
                    </div>
                ) : (
                    <BootstrapDialog
                        aria-labelledby="customized-dialog-title"
                        open={open}
                    >

                        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                            Agent Details
                        </DialogTitle>
                        <IconButton
                            aria-label="close"
                            onClick={handleCloseAgentIcon}
                            sx={(theme) => ({
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                color: theme.palette.grey[500],
                            })}
                        >
                            <CloseIcon />
                        </IconButton>

                        <DialogContent dividers sx={{ overflowX: 'hidden' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                                <div>
                                    <Box style={{ display: 'flex', gap: '10px', width: '570px' }}>
                                        <Box>
                                            <StyledBadge overlap="circular" anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} variant="dot">
                                                <Avatar
                                                    src={
                                                        agentProfileImage
                                                            ? `https://iconnctapp.com/${agentProfileImage}`
                                                            : '/public/assets/BlackAgent.png'
                                                    }
                                                    style={{ width: '65px', height: '65px' }}
                                                    alt={agentDetails?.name}
                                                />
                                            </StyledBadge>
                                        </Box>

                                        <Box>
                                            <Box>
                                                <span style={{ fontSize: '25px', fontWeight: '700', color: '#414D55' }}>
                                                    {agentDetails?.name} {agentDetails?.last_name}
                                                </span>
                                            </Box>

                                            <Box style={{ display: 'flex', gap: '4px' }}>
                                                <div>
                                                    <img src={MarketArea} alt="" style={{ width: '17px' }} />
                                                </div>
                                                <div style={{ display: 'ruby', width: '570px' }}>
                                                    {agentDetails?.userlocation?.map((location, index, array) => (
                                                        <React.Fragment key={index}>
                                                            <div>
                                                                <span style={{ fontSize: '12px', color: '#606060' }}>
                                                                    {location?.region_name} {index < array.length - 1 && <span>,</span>}
                                                                </span>
                                                            </div>
                                                        </React.Fragment>
                                                    ))}
                                                </div>
                                            </Box>
                                            <Box>
                                                <Box style={{ display: 'flex', gap: '3px' }}>
                                                    <img src={LeadConnection} alt="" style={{ width: '17px' }} />{' '}
                                                    <span style={{ fontSize: '12px' }}>Member Since:</span>
                                                    <span style={{ fontSize: '12px', color: '#606060' }}>{formattedDate}</span>
                                                </Box>
                                                <Box>
                                                    <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#252F46' }}>
                                                        🎯: {agentDetails?.score} , 📊: {agentDetails?.quota}
                                                    </span>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>
                                </div>

                                <div style={{ display: 'flex', gap: '10px', marginRight: '12px' }}>
                                    {showPhoneNumber && <span style={{ marginTop: '10px', fontSize: '12px' }}>{agentDetails?.phone}</span>}
                                    {agentDetails?.phone !== null && (
                                        <BsTelephoneFill
                                            style={{ fontSize: '18px', marginTop: '4px', cursor: 'pointer', color: 'black' }}
                                            onClick={() => setShowPhoneNumber(!showPhoneNumber)}
                                            title="Click to show phone number"
                                        />
                                    )}
                                    <a href={gmailComposeUrl} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                                        <MdEmail style={{ fontSize: '23px', cursor: 'pointer', color: 'black' }} title="Compose email in Gmail" />
                                    </a>
                                </div>
                            </div>
                            {/* About Me */}
                            <Card style={{ padding: '10px', width: '720px', borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Box>
                                        <Typography style={{ fontSize: '25px', fontWeight: '700', color: '#414D55' }}>About Me</Typography>
                                    </Box>
                                    {agentDetails?.bio?.length > 90 && (
                                        <Box onClick={toggleExpand} style={{ cursor: 'pointer' }}>
                                            <Typography style={{ color: '#5377bd', fontSize: '14px', fontWeight: '500' }}>
                                                {expandedBio ? 'View Less' : 'View More'}
                                            </Typography>
                                        </Box>
                                    )}
                                </div>
                                <Box style={{ marginTop: '10px' }}>
                                    <Typography>
                                        {expandedBio
                                            ? agentDetails?.bio
                                            : agentDetails?.bio?.substring(0, 90) + (agentDetails?.bio?.length > 90 ? '...' : '')}
                                    </Typography>
                                </Box>
                            </Card>

                            <AgentTags
                                IcaAgentId={agentDetails?.id}
                                IcaAgentTag={IcaAgentTags}
                                IcaGetAgentProfileDetail={getAgentProfileDetail}
                            />
                            {/* Assignment Section */}
                            <Card sx={{ width: 720, mt: 2, borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px' }}>
                                <CardActions disableSpacing>
                                    <Box style={{ display: 'flex' }}>
                                        <Typography style={{ fontSize: '25px', fontWeight: '700', color: '#414D55' }}>Assignment</Typography>
                                    </Box>
                                    <IconButton aria-label="share"></IconButton>
                                    <ExpandMore
                                        expand={expandedAssignment}
                                        onClick={handleExpandAssignmentClick}
                                        aria-expanded={expandedAssignment}
                                        aria-label="show more"
                                    >
                                        <Typography style={{ color: '#5379BD', fontSize: '16px', fontWeight: '700' }}>
                                            {expandedAssignment ? 'View Less' : 'View All'}
                                        </Typography>
                                    </ExpandMore>
                                </CardActions>
                                <Box style={{ display: 'flex' }}>
                                    {assignLead?.length > 0 ? (
                                        assignLead?.slice(0, 4)?.map((leads, index) => {
                                            const { formattedStatus, divStyle } = mapStatusToFormatAndColor(leads?.lead?.status);
                                            return (
                                                <CardContent key={index}>
                                                    <Card
                                                        style={{ height: '200px', width: '150px', cursor: 'pointer' }}
                                                        key={index}
                                                        onClick={() => handleOpenById(leads?.lead)}
                                                    >
                                                        {/* <CardActionArea> */}
                                                        <div style={{ position: 'relative' }}>
                                                            <div
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: '53px',
                                                                    left: '50%',
                                                                    transform: 'translateX(-50%)',
                                                                    zIndex: 10,
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    borderRadius: '4px',
                                                                    padding: '5px',
                                                                }}
                                                            >
                                                                <img src={logo_between} alt="" style={{ width: '34px', height: '34px' }} />
                                                            </div>
                                                        </div>
                                                        <img
                                                            src={`https://maps.googleapis.com/maps/api/staticmap?zoom=13&size=160x100&maptype=roadmap&center=${leads?.lead?.buyer_latitude},${leads?.lead?.buyer_longitude}&key=AIzaSyC9saN_UXZFij-RjWWX9drQEQSZw5PaPcA`}
                                                            alt=""
                                                        />
                                                        <CardContent>
                                                            <Typography style={{ fontSize: '10px', fontWeight: '700', color: '#414D55' }}>
                                                                {leads?.lead?.first_name} {leads?.lead?.last_name}{' '}
                                                            </Typography>
                                                            <Typography
                                                                style={{
                                                                    fontSize: '10px',
                                                                    color: '#414D55',
                                                                    textOverflow: 'ellipsis',
                                                                    whiteSpace: 'nowrap',
                                                                    overflow: 'hidden',
                                                                }}
                                                            >
                                                                Assigned by: {leads?.assignby?.name} {leads?.assignby?.last_name}
                                                            </Typography>
                                                            <div style={{ marginTop: '5px' }}>
                                                                <span
                                                                    style={{
                                                                        ...divStyle,
                                                                        borderRadius: '10px',
                                                                        fontSize: '8px',
                                                                        padding: '3px',
                                                                    }}
                                                                >
                                                                    {formattedStatus}
                                                                </span>
                                                            </div>
                                                        </CardContent>
                                                        {/* </CardActionArea> */}
                                                    </Card>
                                                </CardContent>
                                            );
                                        })
                                    ) : (
                                        <CardContent>
                                            <Typography>No leads available</Typography>
                                        </CardContent>
                                    )}
                                </Box>
                                <Grid container spacing={2}>
                                    {assignLead?.slice(4)?.map((leads, index) => {
                                        const { formattedStatus, divStyle } = mapStatusToFormatAndColor(leads?.lead?.status);
                                        return (
                                            <Grid item xs={12} sm={6} md={3} key={index}>
                                                <Collapse in={expandedAssignment} timeout="auto" unmountOnExit>
                                                    <CardContent>
                                                        <Card style={{ height: '200px', width: '150px' }} onClick={() => handleOpenById(leads?.lead)}>
                                                            <CardActionArea>
                                                                <div style={{ position: 'relative' }}>
                                                                    <div
                                                                        style={{
                                                                            position: 'absolute',
                                                                            top: '53px',
                                                                            left: '50%',
                                                                            transform: 'translateX(-50%)',
                                                                            zIndex: 10,
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            borderRadius: '4px',
                                                                            padding: '5px',
                                                                        }}
                                                                    >
                                                                        <img src={logo_between} alt="" style={{ width: '34px', height: '34px' }} />
                                                                    </div>
                                                                </div>
                                                                <img
                                                                    src={`https://maps.googleapis.com/maps/api/staticmap?zoom=13&size=160x100&maptype=roadmap&center=${leads?.lead?.buyer_latitude},${leads?.lead?.buyer_longitude}&key=AIzaSyC9saN_UXZFij-RjWWX9drQEQSZw5PaPcA`}
                                                                    alt=""
                                                                />
                                                                <CardContent>
                                                                    <Typography style={{ fontSize: '12px', fontWeight: '700', color: '#414D55' }}>
                                                                        {leads?.lead?.first_name} {leads?.lead?.last_name}
                                                                    </Typography>
                                                                    <Typography
                                                                        style={{
                                                                            fontSize: '10px',
                                                                            color: '#414D55',
                                                                            textOverflow: 'ellipsis',
                                                                            whiteSpace: 'nowrap',
                                                                            overflow: 'hidden',
                                                                        }}
                                                                    >
                                                                        Assigned by: {leads?.assignby?.name} {leads?.assignby?.last_name}
                                                                    </Typography>
                                                                    <div style={{ marginTop: '5px' }}>
                                                                        <span
                                                                            style={{
                                                                                ...divStyle,
                                                                                borderRadius: '10px',
                                                                                fontSize: '8px',
                                                                                padding: '3px',
                                                                            }}
                                                                        >
                                                                            {formattedStatus}
                                                                        </span>
                                                                    </div>
                                                                </CardContent>
                                                            </CardActionArea>
                                                        </Card>
                                                    </CardContent>
                                                </Collapse>
                                            </Grid>
                                        );
                                    })}
                                </Grid>
                            </Card>
                            {/* Average Score*/}
                            <Card sx={{ width: '720px', mt: 2, borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px' }}>
                                <CardActions disableSpacing>
                                    <Box style={{ display: 'flex', margin: '15px' }}>
                                        <img src={Scorecard} alt="" style={{ width: '29px' }} />
                                        <Typography style={{ fontSize: '25px', fontWeight: '700', color: '#414D55' }}>Average Score</Typography>
                                    </Box>
                                    <IconButton aria-label="share"></IconButton>
                                    <ExpandMore expand={expanded} onClick={handleExpandClick} aria-expanded={expanded} aria-label="show more">
                                        <Typography style={{ color: '#5379BD', fontSize: '16px', fontWeight: '700' }}>
                                            {expanded ? 'View Less' : 'View All'}
                                        </Typography>
                                    </ExpandMore>
                                </CardActions>

                                {!expanded && (
                                    <CardContent>
                                        <Box style={{ display: 'flex' }}>
                                            {Object.entries(statusCounts)
                                                .slice(0, 4)
                                                .map(([key, detail], index) => (
                                                    <Box key={index} style={{ margin: '20px', textAlign: 'center' }}>
                                                        <Typography
                                                            style={{
                                                                fontSize: '12px',
                                                                color: barColorStatus[key]?.color || '#000',
                                                                marginBottom: '10px',
                                                            }}
                                                        >
                                                            {key
                                                                .replace(/_/g, ' ')
                                                                .split(' ')
                                                                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                                                                .join(' ')}
                                                        </Typography>
                                                        <div style={{ width: 140, height: 140 }}>
                                                            <CircularProgressbar
                                                                value={parseFloat(detail?.percentage)}
                                                                text={`${detail.count}`}
                                                                styles={buildStyles({
                                                                    textColor: barColorStatus[key]?.color || '#000', // Text color of the count
                                                                    pathColor: barColorStatus[key]?.color || '#000',
                                                                    textSize: '16px',
                                                                })}
                                                            />
                                                        </div>
                                                    </Box>
                                                ))}
                                        </Box>
                                    </CardContent>
                                )}

                                <Collapse in={expanded} timeout="auto" unmountOnExit>
                                    <CardContent>
                                        {/* Bam Fam */}
                                        <Box>
                                            <Box style={{ margin: '20px' }}>
                                                <Typography style={{ marginLeft: '12px', fontSize: '20px', fontWeight: '700', color: '#414D55' }}>
                                                    Score of Agent
                                                </Typography>
                                            </Box>
                                        </Box>
                                        {/* Meet With */}
                                        <Box>
                                            <Box style={{ margin: '20px' }}>
                                                {Object.entries(statusCounts).map(([key, detail], index) => (
                                                    <Box key={index} style={{ margin: '20px' }}>
                                                        <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                            <Box>
                                                                <Typography style={{ fontSize: '17px', color: '#414D55' }}>
                                                                    {detail?.count} of {''} {totalStatusCounts}
                                                                </Typography>
                                                            </Box>
                                                            <Box>
                                                                <Typography
                                                                    style={{
                                                                        color: barColorStatus[key]?.color || '#000',
                                                                        fontSize: '17px',
                                                                        fontWeight: 'bold',
                                                                    }}
                                                                >
                                                                    {key
                                                                        .replace(/_/g, ' ')
                                                                        .split(' ')
                                                                        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                                                                        .join(' ')}
                                                                </Typography>
                                                                <Typography style={{ color: '#898989', fontSize: '12px' }}>
                                                                    {dateRange?.start_date} - {dateRange?.end_date}
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                        <Box>
                                                            <BorderLinearProgressTwo
                                                                variant="determinate"
                                                                value={parseFloat(detail.percentage)}
                                                                barColor={barColorStatus[key]?.color || '#000'}
                                                            />
                                                        </Box>
                                                    </Box>
                                                ))}
                                            </Box>
                                        </Box>
                                    </CardContent>
                                </Collapse>
                            </Card>
                            {/* Scheduling Section */}
                            {/* <Card
                                sx={{
                                    width: '720px',
                                    margin: '20px auto',
                                    padding: '16px',
                                    borderRadius: '22px',
                                    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    cursor: 'pointer'
                                }}
                                onClick={handleOpenModal}
                            >
                                <CardContent sx={{ display: 'flex', alignItems: 'center', }}>
                                    <IconButton color="primary">
                                        <CalendarMonthIcon fontSize='large' />
                                    </IconButton>
                                    <Box ml={2}>
                                        <Typography variant="h6" component="div" fontWeight="bold">
                                            Daily Scheduling
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            {format(currentTime, 'MMMM dd, yyyy | hh:mm:ss a')}
                                        </Typography>
                                    </Box>
                                </CardContent>
                                <CardContent>
                                    <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
                                        {agentDetails?.name} {agentDetails?.last_name}
                                    </Typography>
                                </CardContent>
                            </Card> */}


                        </DialogContent>


                    </BootstrapDialog>
                )}
            </>

            {openModal === true && <AgentSchedulingModal open={openModal} onClose={handleCloseModal} agentId={agentDetails?.id} />}
            {leadId && (
                <CustomerLeadProfile
                    selectedProperties={leadId}
                    setSelectedProperties={setSelectedAgent}
                    setProfileAgent={setOpen}
                    handleAssignLead={handleAssignLead}
                />
            )}
            <LogoutExpiredModal setLogOutModal={setLogOutModal} logOutModal={logOutModal} />
        </div>
    );
};
export default AgentProfile;
